import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "../../context/SiteContext";

export default function WhatsAppFloat() {
    const { content } = useSite();
    const num = (content.social?.whatsapp || "").replace(/\D/g, "");
    if (!num) return null;
    return (
        <a
            href={`https://wa.me/${num}?text=Salam,%20KA%20Academy%20haqqında%20məlumat%20almaq%20istəyirəm.`}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-float"
            aria-label="WhatsApp ilə əlaqə"
            className="fixed bottom-6 right-6 z-40 group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
            <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white px-5 py-3.5 rounded-full shadow-2xl shadow-[#25D366]/30 transition-colors">
                <MessageCircle size={20} />
                <span className="hidden sm:inline text-sm font-medium">
                    WhatsApp
                </span>
            </span>
        </a>
    );
}
